import React from 'react'
import { baseUrl } from "services/axiosInstance";
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
export const ImageGrid = ({userProfiles}) => {
    const srcset = (image, size) => {
        return {
          src: `${baseUrl + image}?w=${size}&h=${size}&fit=crop&auto=format`,
          srcSet: `${baseUrl + image}?w=${size}&h=${size}&fit=crop&auto=format&dpr=2 2x`,
        };
      };
  return (
    <ImageList
      sx={{ width: "100%", height: "auto" }}
      variant="masonry"
      cols={5} 
      gap={12}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      {userProfiles.map((item) => (
        <ImageListItem key={item?.image}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <img
            {...srcset(item?.image, 200)}
            alt="Profile image"
            loading="lazy"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            
          />
        </ImageListItem>
      ))}
       </ImageList>
  )
}

export default ImageGrid